<template>
  <vue-scroll :ops="ops">
    <div class="projectDetails">
      <transition name="fade">
        <div
          class="spinner"
          v-if="spinnerOn">
          <img src="../assets/img/spinner.gif" alt="">
        </div>
      </transition>
      <transition name="detailsTransition">
        <article
          v-if="show"
          class="projectDetails__info">
          <h1 v-html="projectDetails.title.rendered"></h1>
          <div class="projectDetails__info__client">
            <b>Client:</b><span> {{ projectDetails.acf.client }}</span>
          </div>
          <ul class="projectDetails__info__tags">
            <li v-for="tag in projectTags"
                  v-bind:key = "tag">{{ tag }}</li>
          </ul>
          <div class="projectDetails__info__siteUrl"
              v-if="projectDetails.acf.site_url">
            <a :href="projectDetails.acf.site_url"> {{ projectDetails.acf.site_url }}</a>
          </div>
          <div class="projectDetails__info__content">
            <div v-html="projectDetails.content.rendered"></div>
          </div>
          <div>
            <div v-for="projectImage in projectImages"
                v-bind:key ="projectImage.id"
                class="imgContainer">
                <img v-lazy="projectImage.url"
                  :alt="projectImage.description"
                  class="lazyImage">
                  <!-- <img :src="projectImage.url" :alt="projectImage.description"> -->
            </div>
          </div>
        </article>
      </transition>
    </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'ProjectDetails',
  props: ['projectId'],
  data () {
    return {
      show: true,
      spinnerOn: false,
      projectDetails: {},
      projectTitle: '',
      projectImages: [],
      projectTags: [],
      ops: {
        rail: {
          opacity: '0'
        },
        bar: {
          background: '#666',
          opacity: 0.4
        },
        scrollPanel: {
          easing: 'easeInQuad',
          speed: 800
        }
      }
    }
  },
  created () {
  },
  watch: {
    projectId: function (newVal, oldVal) {
      if (newVal) {
        // Show old project details
        this.show = false
        // Show Loader
        this.spinnerOn = true
        // Reuqest project details
        this.$http.get('wp/v2/projects/' + newVal).then(response => {
          // Recover project details
          this.projectDetails = response.data
          this.projectImages = response.data.acf.project_images
          this.projectTags = response.data.tag_names
          // Hide Loader
          this.spinnerOn = false
          // Show new project details
          this.show = true
        }, error => {
          // Error recovering project details
          alert('Error recovering project details: ' + error)
        })
      } else {
        this.show = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.projectDetails {
  padding: 0 $gutter/2;
  height: 100vh;
  position: relative;
  @media (min-width: 768px) {
    padding: 0 $gutter;
  }
}
.projectDetails__info {
  padding-top: 80px;
  @media (min-width: 768px) {
    padding-top: 0;
  }
  h1 {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 0;
    margin-top: 0;
    padding-top: $gutter;
  }
  .projectDetails__info__client {
    font-style: italic;
    margin-bottom: 10px;
  }
  .projectDetails__info__tags {
    list-style: none;
    padding: 0;
    li {
      display: inline-block;
      font-size: 0.8rem;
      padding: 0.6em 1em;
      margin-right: 5px;
      margin-bottom: 5px;
      @include roundedAllCorners(5px);
      color: #a0a0a0;
      border: 1px solid #dddddd;
    }

  }
  .projectDetails__info__siteUrl {
    background-color: #f7f7f7;
    @include roundedAllCorners($gutter/2);
    a {
      display: inline-block;
      width: 100%;
      padding: $gutter/2;
      color: #868686 !important;
      text-decoration: none;
      letter-spacing: 2px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .projectDetails__info__content {
    margin-top: $gutter;
    margin-bottom: $gutter;
  }
  .imgContainer {
    width: 100%;
    height: 62.5%;
    margin-bottom: 20px;
    border: 1px solid #efefef;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

}
/* TRANSITIONS */
.detailsTransition-enter-active, .detailsTransition-leave-active {
  transition: all 1s;
}
.detailsTransition-enter, .detailsTransition-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectDetails.vue